import {
  MotifButton,
  MotifButtonGroup,
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
} from "@ey-xd/motif-react";
import { IconoirNavArrowDown } from "@ey-xd/motif-icon";
import { useState } from "react";

const SplitButton = ({
  label = "Action",
  variant = "secondary",
  size = "small",
  disabled = false,
  ariaLabel = "Split button",
  dropDownList = ["Option 1", "Option 2"],
  onClick,
  onSelectItem,
  isItemDisabled = () => false,
}) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleMainButtonClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleItemSelect = (item) => {
    if (isItemDisabled(item)) return;
    if (onSelectItem) {
      onSelectItem(item);
    }
    setShowMenu(false);
  };

  return (
    <MotifButtonGroup>
      <MotifButton
        variant={variant}
        size={size}
        disabled={disabled}
        onClick={handleMainButtonClick}
        aria-label={ariaLabel}
      >
        {label}
      </MotifButton>

      <MotifDropdown
        open={showMenu}
        onClose={() => setShowMenu(false)}
        trigger={
          <MotifButton
            type="button"
            variant={variant}
            size={size}
            disabled={disabled}
            onClick={() => setShowMenu(!showMenu)}
            aria-label={`${ariaLabel} dropdown`}
            aria-haspopup="true"
            aria-expanded={showMenu}
          >
            <MotifIcon
              aria-label="Dropdown icon"
              iconFunction={IconoirNavArrowDown}
            />
          </MotifButton>
        }
      >
        {dropDownList.map((item, index) => (
          <MotifDropdownItem
            key={`dropdown-item-${index}`}
            disabled={isItemDisabled(item)}
            onClick={() => handleItemSelect(item)}
          >
            {item}
          </MotifDropdownItem>
        ))}
      </MotifDropdown>
    </MotifButtonGroup>
  );
};


export default SplitButton;
